import { InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { EntityMeta } from '../../base/EntityMeta'
import type { Order } from '../Order'

@InputType()
export class GetMyOrderListArgs extends ActionArgs {
  status?: unknown
  limit?: unknown
  skip?: unknown
  sort?: unknown
}

export interface IGetMyOrderList extends IAction<Order[], GetMyOrderListArgs> {}
export interface IGetMyOrderListMeta extends IAction<EntityMeta, GetMyOrderListArgs> {}
